function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.475c-.3.117-.567.058-.8-.175-.233-.233-.292-.5-.175-.8l3.325-9.275c.183-.533.546-.858 1.088-.975.541-.117 1.004.017 1.387.4l5.05 5c.4.383.542.846.425 1.388-.117.541-.442.904-.975 1.087L3.5 21.475zm10-9.025a.579.579 0 01-.175-.425c0-.167.058-.308.175-.425l5.575-5.575c.533-.533 1.208-.804 2.025-.813.817-.008 1.492.255 2.025.788l.025.025a.55.55 0 01.175.4c0 .15-.067.292-.2.425a.579.579 0 01-.425.175.579.579 0 01-.425-.175l-.05-.05c-.317-.317-.683-.48-1.1-.488-.417-.008-.792.155-1.125.488l-5.675 5.675a.55.55 0 01-.4.175c-.15 0-.292-.067-.425-.2zM9.525 8.575a.579.579 0 01-.175-.425c0-.167.058-.308.175-.425L9.85 7.4c.383-.383.563-.82.537-1.313A1.819 1.819 0 009.85 4.85l-.3-.3a.55.55 0 01-.175-.4c0-.15.067-.292.2-.425A.579.579 0 0110 3.55c.167 0 .308.058.425.175l.225.225c.583.583.87 1.312.862 2.187-.008.875-.304 1.605-.887 2.188l-.275.275a.55.55 0 01-.4.175c-.15 0-.292-.067-.425-.2zM11.55 10.5a.579.579 0 01-.175-.425c0-.167.058-.308.175-.425l3.375-3.375c.317-.317.47-.72.462-1.213-.008-.491-.17-.895-.487-1.212l-1.125-1.125a.55.55 0 01-.175-.4c0-.15.067-.292.2-.425a.579.579 0 01.425-.175c.167 0 .308.058.425.175l1.15 1.15c.517.533.783 1.204.8 2.012.017.809-.242 1.48-.775 2.013l-3.45 3.45a.55.55 0 01-.4.175c-.15 0-.292-.067-.425-.2zm3.95 3.975a.579.579 0 01-.175-.425c0-.167.058-.308.175-.425l.75-.75a2.954 2.954 0 012.1-.9 2.778 2.778 0 012.1.85l.875.875a.55.55 0 01.175.4c0 .15-.067.292-.2.425a.579.579 0 01-.425.175.579.579 0 01-.425-.175l-.875-.875c-.383-.383-.783-.575-1.2-.575-.417 0-.817.192-1.2.575l-.85.85a.55.55 0 01-.4.175c-.15 0-.292-.067-.425-.2z"
  }));
};
const SvgCelebration = styled(BaseComponent).withConfig({
  displayName: "Celebration__SvgCelebration",
  componentId: "sc-10lfj3r-0"
})(["outline:none;"]);
SvgCelebration.isIcon = true;
SvgCelebration.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgCelebration;